import { TypedMultipleParam } from "./_Multiple";
import { Vector2 } from "three";
import { ParamType } from "../poly/ParamType";
import { CoreType } from "../../core/Type";
const COMPONENT_NAMES_VECTOR2 = ["x", "y"];
export class Vector2Param extends TypedMultipleParam {
  constructor() {
    super(...arguments);
    this._value = new Vector2();
    this._copied_value = [0, 0];
  }
  static type() {
    return ParamType.VECTOR2;
  }
  componentNames() {
    return COMPONENT_NAMES_VECTOR2;
  }
  defaultValueSerialized() {
    if (CoreType.isArray(this._default_value)) {
      return this._default_value;
    } else {
      return this._default_value.toArray();
    }
  }
  valueSerialized() {
    return this.value.toArray();
  }
  _copyValue(param) {
    param.value.toArray(this._copied_value);
    this.set(this._copied_value);
  }
  _cloneRawInput(raw_input) {
    if (raw_input instanceof Vector2) {
      return raw_input.clone();
    } else {
      const new_array = [raw_input[0], raw_input[1]];
      if (new_array[0] == null) {
        new_array[0] = new_array[0] || 0;
      }
      if (new_array[1] == null) {
        new_array[1] = new_array[1] || new_array[0];
      }
      return new_array;
    }
  }
  static areRawInputEqual(raw_input1, raw_input2) {
    if (raw_input1 instanceof Vector2) {
      if (raw_input2 instanceof Vector2) {
        return raw_input1.equals(raw_input2);
      } else {
        return raw_input1.x == raw_input2[0] && raw_input1.y == raw_input2[1];
      }
    } else {
      if (raw_input2 instanceof Vector2) {
        return raw_input1[0] == raw_input2.x && raw_input1[1] == raw_input2.y;
      } else {
        return raw_input1[0] == raw_input2[0] && raw_input1[1] == raw_input2[1];
      }
    }
  }
  static areValuesEqual(val1, val2) {
    return val1.equals(val2);
  }
  initComponents() {
    super.initComponents();
    this.x = this.components[0];
    this.y = this.components[1];
  }
  set_value_from_components() {
    this._value.x = this.x.value;
    this._value.y = this.y.value;
  }
}
